import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetProjectInformation = createAsyncThunk(
  "ProjectInformation/GetProjectInformation",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationAboutProject/GetInformationAboutProjectData",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "malekho");

      //console.log(data, "data");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateInformationAboutProjectt = createAsyncThunk(
  "ProjectInformation/UpdateInformationAboutProject",
  async (updateInfo, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationAboutProject/UpdateInformationAboutProject",
        {
          informationAboutProject: updateInfo.informationAboutProject,
          projectNameTitle: updateInfo.projectNameTitle,
          oneSentencePitch: updateInfo.oneSentencePitch,
          nameCountryWhichProjectWillBeImplemented:
            updateInfo.nameCountryWhichProjectWillBeImplemented,
          whatIsProblemYouAreSolving: updateInfo.whatIsProblemYouAreSolving,
          listMainObjectivesAchieveWithThisFund:
            updateInfo.listMainObjectivesAchieveWithThisFund,
          aP_CountryOfProjectImplementationId:
            updateInfo.aP_CountryOfProjectImplementationId,
          aI_ApplicationInformationId: updateInfo.aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "qqqq");

      //console.log(data, "data");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateProjectInformation = createAsyncThunk(
  "ProjectInformation/ValidateAdvertisingPlan",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationAboutProject/ValidateInformationAboutProject",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });

        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ProjectInformation = createSlice({
  name: "ProjectInformation",
  initialState: {
    ProjectInformation: {},
    loadingGetProjectInformation: false,
    errorGetProjectInformation: null,

    ProjectInformationValidate: [],
    loadingProjectInformationValidate: false,
    errorProjectInformationValidate: null,

    UpdateInfoAboutProject: {},
    loadingUpdateInfoAboutProject: false,
    errorUpdateInfoAboutProject: null,
  },
  reducers: {
    SetProjectInformation: (state, action) => {
      state.ProjectInformation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetProjectInformation.pending, (state, action) => {
        state.loadingGetProjectInformation = true;
        state.ProjectInformation = action.payload;
        state.errorGetProjectInformation = null;
      })
      .addCase(GetProjectInformation.fulfilled, (state, action) => {
        state.loadingGetProjectInformation = false;
        state.ProjectInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetProjectInformation.rejected, (state, action) => {
        state.loadingGetProjectInformation = false;
        state.errorGetProjectInformation = action.payload;
      })

      .addCase(ValidateProjectInformation.pending, (state, action) => {
        state.loadingProjectInformationValidate = true;
        state.ProjectInformationValidate = action.payload;
        state.errorProjectInformationValidate = null;
      })
      .addCase(ValidateProjectInformation.fulfilled, (state, action) => {
        state.loadingProjectInformationValidate = false;
        state.ProjectInformationValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateProjectInformation.rejected, (state, action) => {
        state.loadingProjectInformationValidate = false;
        state.errorProjectInformationValidate = action.payload;
      })
      ////////////////////////////////////update//////////////////////////////////
      .addCase(UpdateInformationAboutProjectt.pending, (state, action) => {
        state.loadingUpdateInfoAboutProject = true;
        state.UpdateInfoAboutProject = action.payload;
        state.errorUpdateInfoAboutProject = null;
      })
      .addCase(UpdateInformationAboutProjectt.fulfilled, (state, action) => {
        state.loadingUpdateInfoAboutProject = false;
        state.UpdateInfoAboutProject = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateInformationAboutProjectt.rejected, (state, action) => {
        state.loadingUpdateInfoAboutProject = false;
        state.errorUpdateInfoAboutProject = action.payload;
      });
  },
});
export const { SetProjectInformation } = ProjectInformation.actions;

export default ProjectInformation.reducer;
